export enum ScopeThreeWasteTreatmentEnums {
    RECYCLED = "recycled",
    LANDFILLED = "landfilled",
    COMBUSTED = "combusted",
    COMPOSTED = "composted",
    ANAEROBICALLY_DIGESTED_DRY = "anaerobically_digested_dry",
    ANAEROBICALLY_DIGESTED_WET = "anaerobically_digested_wet",
}